import React from "react";

export const BP_CATEGORY_COLOR = {
  "Normal": "#4ADE80",
  "Elevated": "#FBBF24",
  "Stage 1 HTN": "#FB923C",
  "Stage 2 HTN": "#F87171",
  "Hypertensive crisis": "#DC2626",
};

export const ASCVD_COLOR = { Low: "#4ADE80", Borderline: "#FBBF24", Intermediate: "#FB923C", High: "#F87171" };
export const HEART_COLOR = { Low: "#4ADE80", Moderate: "#FB923C", High: "#F87171" };

export function fmtDate(iso) {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleDateString(); } catch { return iso; }
}

export function Field({ label, children, testId }) {
  return (
    <label className="block" data-testid={testId ? `field-${testId}` : undefined}>
      <div className="text-[10px] uppercase tracking-wider text-[#A3ACA7] mb-1">{label}</div>
      {children}
    </label>
  );
}

export function Checkbox({ label, checked, onChange, testId }) {
  return (
    <label className="inline-flex items-center gap-2 cursor-pointer text-white" data-testid={testId}>
      <input type="checkbox" checked={!!checked}
             onChange={(e) => onChange(e.target.checked)}
             className="accent-[#F87171]" />
      {label}
    </label>
  );
}

export function BPCategoryBadge({ category }) {
  const color = BP_CATEGORY_COLOR[category] || "#A3ACA7";
  return (
    <span
      className="inline-block text-[10px] font-bold px-2.5 py-1 rounded-full"
      data-testid="bp-category-badge"
      style={{ color, background: `${color}18`, border: `1px solid ${color}40` }}
    >
      {(category || "unknown").toUpperCase()}
    </span>
  );
}

export function LipidStat({ label, value, target, flagged, inverted }) {
  const color = flagged ? "#F87171" : "#4ADE80";
  return (
    <div>
      <div className="text-[10px] uppercase tracking-wider text-[#A3ACA7]">{label}</div>
      <div className="text-xl font-mono font-bold" style={{ color }}>{value}</div>
      <div className="text-[10px] text-[#7A8480]">Target {target}{inverted ? " (higher is better)" : ""}</div>
    </div>
  );
}
